import { AxiosPromise } from 'axios';

import { _ILookup, ILookupAddValue, ILookupRemoveValue } from './interfaces';
import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';

const basePath = '/lookups';

/* eslint-disable implicit-arrow-linebreak */

export const getLookups = <T>(vendorSport?: string, name?: string): AxiosPromise<IApiResponse<_ILookup[]>> => vaultApi.getInstance().get(basePath, {
  params: { vendorSport, name },
});

export const addValuesToLookup = <T>(id: string, params: ILookupAddValue[]): AxiosPromise<any> => vaultApi.getInstance().put(`${basePath}/addValues/${id}`, params);

export const removeValuesFromLookup = <T>(id: string, params: ILookupRemoveValue[]): AxiosPromise<any> => vaultApi.getInstance().put(`${basePath}/removeValues/${id}`, params);
